<template>
  <div>
    <Navbar activeDirectory="admin" activePage="geometra-squadra"></Navbar>
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead class="thead-light">
                    <th>Squadra</th>
                    <th>Supervisore</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <tr v-for="item in gTeams" v-bind:key="item.id">
                      <td>{{ item.team.name }}</td>
                      <td>
                        <select v-model="item.geometra.id" class="form-control" @change="unsaved[item.id]=true;">
                          <option value="null" disabled>Seleziona supervisore dalla lista....</option>
                          <option v-for="geom in geometras" :value="geom.id" v-bind:key="geom.id">{{ geom.fullname }}</option>
                        </select>
                      </td>
                      <td>
                        <button class="btn btn-sm btn-primary" v-if="unsaved[item.id]" @click="item=item; saveChanges(item)">
                          <i class="ti ti-save"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>             
            </div>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar } from "@/components";

export default {
  components: {
    Navbar
  },

  data() {
    return {
      tipologia: localStorage.getItem("tipologia"),
      gTeams: [],
      unsaved: {},
      geometras: [],
      itemEditID: null,
      itemEdit: null
    };
  },

  mounted() {
    if (this.tipologia !== "B" && this.tipologia !== "D") {
      this.$router.push({ name: "home" });
    } else {
      this.fetchGeometras();
      this.fetchGeometraTeams();
    }
  },

  watch : {
    itemEditID (nv, ov) {
      if (nv != ov ) {
        this.sCahnged (this.itemEdit);
      }      
    }
  },

  methods: {
    /**
     * fetchGeometraTeams
     * 
     * Get geometra for each team
     * 
     * 2020-08-25 [fmarigliano@bidata.it] - Method creation
     */
    fetchGeometraTeams(){
      this.axios.get('/geometra-teams').then(response=>{
        let gTeams = response.data

        this.gTeams = gTeams
        
        for (var i in gTeams) {
          this.unsaved[gTeams[i].id] = false
        } 
      })
    },

    /**
     * fetchGeometras
     * 
     * Get geometras
     * 
     * 2020-08-25 [fmarigliano@bidata.it] - Method creation
     */
    fetchGeometras(){
      this.geometras = []
      this.axios.get("/get-users").then((response) => {
        let users = response.data 
        for ( var i in users ) {
          if( users[i].group == 'G' ) {
            this.geometras.push(users[i])
          }
        }
      });
    },

    /**
     * saveChanges
     * 
     * Save geometra changes
     * 
     * - item
     * 
     * 2020-08-25 [fmarigliano@bidata.it] - Method creation
     */
    saveChanges(item){
      var formData = new FormData()
      formData.append('id', item.id)
      formData.append('fk_geometra', item.geometra.id)
      this.unsaved[item.id]=false
      this.unsaved = JSON.parse ( JSON.stringify(this.unsaved) ) // turnaround for reactive
      this.axios.put('/geometra-teams', formData)    
    }
  },

  

}
</script>

<style>

</style>